import { mapActions, mapState } from 'vuex';

import funcoes from "../util/funcoes.js";
import { BANCOS, STATUS_CAIXA, DETALHES_PAGAMENTO_LANCAMENTO_CAIXA } from "../util/constantes";

import AppBuscarChequeDialog from './dialogs/BuscarChequeDialog.vue';
import AppLancamentoCaixaDialog from './dialogs/LancamentoCaixaDialog.vue';
import AppFecharCaixaDialog from './dialogs/FecharCaixaDialog.vue';

import { Money } from "v-money";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMoneyBillAlt, faUniversity, faUnlock } from '@fortawesome/free-solid-svg-icons';

library.add(faMoneyBillAlt, faUniversity, faUnlock)

export default {
  components: {
    AppBuscarChequeDialog,
    AppLancamentoCaixaDialog,
    AppFecharCaixaDialog,

    Money,

    FontAwesomeIcon
  },
  data() {
    return {
      dataInicio: funcoes.primeiroDiaMes(),
      dataFim: funcoes.ultimoDiaMes(),

      lancamentoSelecionado: {},

      caixaHistorico: {},
      lancamentoHistoricoSelecionado: {},

      visibilidadeBuscarChequeDialog: false,
      visibilidadeLancamentoCaixaDialog: false,
      visibilidadeFecharCaixaDialog: false,

      // GERAL
      tabSelecionada: 'caixaAberto',
      statusRecibos: [
        { label: 'Em Aberto', data: 'EM_ABERTO' },
        { label: 'Pago', data: 'PAGO' }
      ],

      xls: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      isExibirDetalhesLancamentos: false,
      
      hoverFecharCaixa: false,
      hoverRelatorio: false
    }
  },
  created() {
    this.recuperarCaixaAnteriorHandler()
    this.limparCampos()
    if(!this.exibirAbaCaixa) {
      this.tabSelecionada = 'historico';
    }
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CAIXA" })[0] }
    }),
    ...mapState('caixaStore', {
      caixaAberto(state) { return state.caixaAberto },
      caixaAnterior(state) { return state.caixaAnterior },
      historico(state) { return state.historico },

      saldo(state) { return state.saldo },

      // VISIBILIDADE
      exibirContainerAbrirCaixa() {
        return (this.tabSelecionada === 'caixaAberto' && (!this.caixaAberto || !this.caixaAberto.id || this.caixaAberto.id === 0))
      },
      exibirBotaoFecharCaixa() {
        return (this.permissoes.abrirFecharCaixa && (this.caixaAberto && this.caixaAberto.status == 'ABERTO'))
      },
      exibirBotaoBuscarCheque() {
        return (this.tabSelecionada === 'historico' && this.permissoes.visualizarHistoricoCaixa)
      },
      exibirBotaoNovoLancamento() {
        return (this.tabSelecionada === 'caixaAberto' && this.permissoes.abrirFecharCaixa)
      },
      desabilitarEdicaoSaldos() {
        return (!this.usuarioLogado.imobiliaria.parametros.alterarValorAberturaCaixa)
      },
      exibirAbaCaixa() {
        return this.permissoes.abrirFecharCaixa;
      },
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('caixaStore', [
      'abrirCaixa',
      'recuperarCaixaAberto',
      'recuperarCaixaAnterior',
      'recuperarHistorico',
      'recuperarHistoricoCheque',
      'removerLancamento'
    ]),
    ...mapActions('financeiroRelatoriosStore', [
      'gerarRelatorio'
    ]),
    abrirCaixaHandler() {
      this.showLoading()
      this.abrirCaixa(this.caixaAnterior).then(resultado => {
        this.hideLoading()
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
        .catch(() => {
          this.hideLoading()
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    recuperarCaixaAbertoHandler() {
      this.showLoading()

      this.recuperarCaixaAberto({ usuario: { id: this.usuarioLogado.id } })
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        });
    },
    recuperarCaixaAnteriorHandler() {
      this.showLoading()

      this.recuperarCaixaAnterior({ usuario: { id: this.usuarioLogado.id } })
        .then(() => {
          this.hideLoading()
          this.recuperarCaixaAbertoHandler();
        })
        .catch(() => {
          this.hideLoading()
        });
    },
    recuperarHistoricoHandler() {
      this.showLoading()
      this.isExibirDetalhesLancamentos = false
      this.lancamentoHistoricoSelecionado = {}
      this.caixaHistorico = {}

      this.recuperarHistorico({ dataInicio: this.dataInicio + " 00:00", dataFim: this.dataFim + " 23:59" })
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    removerLancamentoHandler(lancamento) {
      this.$confirm('Tem certeza que deseja remover este lançamento?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.showLoading()
        this.removerLancamento({ id: lancamento.id, caixa: { id: this.caixaAberto.id } }).then(resultado => {
          this.hideLoading()
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        });
      });
    },

    // DIALOGS
    exibirBuscarChequeDialog() {
      this.visibilidadeBuscarChequeDialog = true
    },
    fecharBuscarChequeDialog() {
      this.visibilidadeBuscarChequeDialog = false;
    },
    exibirLancamentoCaixaDialog() {
      this.visibilidadeLancamentoCaixaDialog = true
    },
    fecharLancamentoCaixaDialog() {
      this.visibilidadeLancamentoCaixaDialog = false;
    },
    exibirFecharCaixaDialog() {
      this.visibilidadeFecharCaixaDialog = true
    },
    fecharFecharCaixaDialog(result) {
      this.visibilidadeFecharCaixaDialog = false;
      if (result && result === 'SUCESSO') {
        this.recuperarCaixaAnteriorHandler()
        this.limparCampos()
      }
    },

    // UTIL
    getLabelStatusCaixa(item) {
      return funcoes.getLabel(STATUS_CAIXA, item.status)
    },
    getLabelDetalhesLancamentoCaixa(item) {
      return funcoes.getLabel(DETALHES_PAGAMENTO_LANCAMENTO_CAIXA, item.formaPagamento)
    },
    getLabelBanco(item) {
      return funcoes.getLabel(BANCOS, item.bancoCheque)
    },
    formatarValor(item) {
      return funcoes.formatarValor(Number((item.operacao === 'SAIDA' ? '-' : '') + item.valor))
    },
    formatarSaldo(item) {
      return funcoes.formatarValor(item)
    },
    getStatusCaixa(item) {
      return funcoes.getLabel(STATUS_CAIXA, item.status)
    },

    gerarRelatorioHandler(command) {
      let nomeRelatorio = ''

      switch (command) {
        case 'cheque':
          nomeRelatorio = 'CHEQUES_DO_CAIXA'
          break;
        case 'movimento':
          nomeRelatorio = 'MOVIMENTO_DO_CAIXA'
          break;
      }

      if (this.tabSelecionada === 'historico' && (!this.caixaHistorico.id || this.caixaHistorico.id === 0)) {
        this.$message.warning("Selecione um Caixa do Histórico");
        return
      }

      let payload = {
        nome: nomeRelatorio,
        xls: this.xls,
        caixa: {
          id: this.tabSelecionada === 'caixaAberto' ? this.caixaAberto.id : this.caixaHistorico.id
        }
      }

      this.showLoading();
      this.gerarRelatorio(payload)
        .then((response) => {
          this.hideLoading();
          switch (response.status) {
            case "SUCESSO":
              window.open(response.mensagem, '_blank');
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },

    selecionarLancamento(row) {
      this.lancamentoSelecionado = row
    },
    selecionarCaixaHistorico(row) {
      this.caixaHistorico = row
    },
    selecionarLancamentoHistorico(row) {
      this.lancamentoHistoricoSelecionado = row
    },
    limparCampos() {
      this.lancamentoSelecionado = {}

      this.lancamentoHistoricoSelecionado = {}
      this.caixaHistorico = {}

      this.dataInicio = funcoes.primeiroDiaMes()
      this.dataFim = funcoes.ultimoDiaMes()
    },
    exibirDetalhesLancamentos() {
      this.isExibirDetalhesLancamentos = true;
    },
    hiddenDetalhesLancamentos() {
      this.isExibirDetalhesLancamentos = false;
    }
  }
}